export default __webpack_public_path__ + "static/media/project-status.3abe8fee.svg";